import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { setContext } from 'apollo-link-context';
import { ApolloProvider, ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { useUser } from '@luigiclaudio/ga-auth-theme';
import { Loader } from '@luigiclaudio/ga-baseline-ui/helpers';

const Apollo = ({ children }) => {
    // TODO: test using the user from the identity, no checks run at this point
    const [user, isLoading] = useUser();

    // eslint-disable-next-line no-console
    // console.log('apollo user', user);

    const accessToken = get(user, 'token.access_token');

    // eslint-disable-next-line no-console
    // console.log('apollo accessToken', accessToken);

    const authLink = setContext((_, { headers }) => {
        return {
            headers: {
                ...headers,
                Authorization: accessToken ? `Bearer ${accessToken}` : '',
            },
        };
    });

    const httpLink = new HttpLink({
        uri: 'https://jotty.netlify.app/.netlify/functions/graphql',
    });

    const client = new ApolloClient({
        cache: new InMemoryCache({
            typePolicies: {
                Query: {
                    fields: {
                        todos: {
                            merge: false,
                        },
                    },
                },
            },
        }),
        link: authLink.concat(httpLink),
    });

    return (
        <ApolloProvider client={client}>
            {isLoading && <Loader isFullScreen />}
            {children}
        </ApolloProvider>
    );
};

Apollo.propTypes = {
    children: PropTypes.node,
};

Apollo.defaultProps = {
    children: undefined,
};

export default Apollo;
